export default __webpack_public_path__ + "static/media/pixer.8c540931.png";